module.exports = __webpack_public_path__ + "img/bed.be5030ca.webp";